import type { Resolvers } from '../../generated';
import { uploaderConfigsMap } from './uploader-configs';

export const resolvers: Resolvers = {
  Mutation: {
    setUploaderConfig: (_, { key, value }) => {
      uploaderConfigsMap.set(key, value);
      return true;
    },
  },
};
